import { ActionType, createAction } from 'typesafe-actions'

import { Dictionary } from '../../../utils/types'

import { ColumnSorting } from '../../table/types'

import { InvitedUser } from './types'

export const ProfileManagementActions = {
  loadInvitedUsers: createAction('PROFILE-MANAGEMENT/load-invited-users')<{
    page: number
    pageSize: number
    sorting?: Dictionary<ColumnSorting>
  }>(),
  reloadInvitedUsers: createAction('PROFILE-MANAGEMENT/reload-invited-users')(),
  setInvitedUsers: createAction('PROFILE-MANAGEMENT/set-invited-users')<{
    page: number
    totalPages: number
    data: InvitedUser[]
  }>(),
  setFilters: createAction('PROFILE-MANAGEMENT/set-filters')<Dictionary<any>>(),
  clearFilter: createAction('PROFILE-MANAGEMENT/clear-filter')<{ filterKey: string }>(),
  setSearchFilter: createAction('PROFILE-MANAGEMENT/set-search-filter')<string>(),
  openDialogToInvitationLinkGeneration: createAction('PROFILE-MANAGEMENT/dialog-InvitationLink')()
}

export type ProfileManagementActions = ActionType<typeof ProfileManagementActions>
